
















import Vue from 'vue';
import { Component, Watch, Prop } from 'vue-property-decorator';
import { KSpinner } from '@kasasa/fbase-components';

import { AuthGroupManager } from '@kasasa/fbase-components/lib';
import PageProfileListTable from '@/components/PageProfileListTable.vue';

import { PageProfile } from '@/services/api';
import PageProfileService from '@/services/PageProfileService';


import { namespace } from 'vuex-class';
import { GroupPerms } from '@/store';
const auth = namespace('auth');

@Component({
	components: {
		KSpinner,
		PageProfileListTable,
	}
})
export default class ListPageProfilesPage extends Vue {
	@auth.State('authManager') authManager!: AuthGroupManager;

	@Prop() clientId !: number;
	@Prop() siteId !: number;

	status: 'loading' | 'loaded' | 'empty' = 'loading';

	pageProfiles: PageProfile[] = [];
	pageProfileSvc = new PageProfileService(this.$store);

	get ro() : boolean{
		return !this.authManager.canWrite(GroupPerms.MAIN_PERM);
	}

	@Watch('$route', {immediate: true, deep: true})
	loadItems(): void {
		this.status = 'loading';
		this.pageProfiles = [];

		this.pageProfileSvc.findAll(this.clientId, this.siteId)
			.then((resp) => {
				this.pageProfiles = resp.data.data;
				this.status = (this.pageProfiles.length ? 'loaded' : 'empty');
			});
	}

}
